import React from 'react'
import { AppBarBottom, CompAnuncios, CompEmpresa, CompTorneio } from '../../Complex/'
import { Typography, Grid, Box } from '@mui/material'
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5'
import { InputButton, InputPesquisa, Loading, Location } from '../../Simple'
import { BiChevronDown } from 'react-icons/bi'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { ModalLocation } from '../../Modais'
import { AuthContext } from '../../../contexts/AuthContext'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import RouterHook from '../../../contexts/RouterHook'
import CompProxAgend from './CompProxAgend/CompProxAgend'

import './stylesEmp.css'

export default function MobileEmpresas() {
  const serverRouter = RouterHook()
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)
  const { actionsCtxEmps, sttPg, inps, loads, modaisCE } = React.useContext(EmpresasContext)

  return (
    <div className='contain-page-mobile' style={{ overflow: 'auto' }}>
      {modaisCE.modalL && (
        <ModalLocation
          show={modaisCE.modalL}
          onClose={() => actionsCtxEmps.handleModaisCE('modalL', false)}
        />
      )}
      <Box sx={{ width: '100%', height: '20px' }}>
        <Typography component='h2' className='title-aplication'>
          Agendei Quadras
        </Typography>
      </Box>
      <Box>
        <InputButton
          fullWidth
          variant='text'
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
            pad: '0px',
            marginTop: '10px',
          }}
          onClick={() => {
            actionsCtxEmps.handleModaisCE('modalL', true)
          }}
        >
          <Location
            cidade={userUCtx.cidade?.nomeCidade}
            estado={userUCtx.cidade?.estado.nomeEstado}
          />
          <BiChevronDown className='btt-icon-down' size={25} />
        </InputButton>
      </Box>
      <Grid container sx={stDesk.containGridPage}>
        <CompAnuncios anuncios={userUCtx.anuncios} />
        <Grid item xs='auto' sx={{ width: '100%', marginTop: '5px' }}>
          <CompProxAgend />
        </Grid>
        {
          // Só mostra se tiver pelo menos um torneio
          sttPg.empresas?.some(emp => emp.torneios?.length > 0) && (
            <Grid item xs={12} sx={{ height: 'auto', width: '100%' }}>
              <Typography component='p' className='text-title-comp'>
                Competições
              </Typography>
              <Box sx={stDesk.containGridTorneios}>
                {sttPg.empresas?.some(emp => emp.torneios?.length > 0) && (
                  <>
                    {sttPg.empresas.map((emp, idx) => (
                      <React.Fragment key={idx}>
                        {emp.torneios?.map((torneio, idx2) => (
                          <React.Fragment key={idx2}>
                            <CompTorneio
                              nomeEmpresa={emp.nome}
                              fotoEmpresa={emp.urlFoto + emp.foto}
                              torneio={torneio}
                              onClick={() => {
                                serverRouter('torneio', torneio.idtorneio)
                              }}
                            />
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                )}
              </Box>
            </Grid>
          )
        }
        <Grid item xs={12} sx={{ width: '100%' }}>
          <Typography component='p' className='text-title-comp'>
            Centros Esportivos
          </Typography>

          {sttPg.empresas?.length > 0 && (
            <InputPesquisa
              input={inps.search}
              onChange={e => actionsCtxEmps.handleInps('search', e.target.value)}
              onClick={() => {}}
              textPlace={'Pesquisar por Centro Esportivo'}
              width={'100%'}
            />
          )}

          <div
            className='contain-list-empresas'
            style={{
              paddingBottom: '0px',
            }}
          >
            {loads.empresas ? (
              <div className='contain-loading'>
                <Loading text={'Carregando...'} />
              </div>
            ) : sttPg.empresas?.length ? (
              <Box
                sx={{
                  width: '100%',
                  height: 'calc(100% - 60px)',
                  pb: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Box width={'100%'}>
                  {sttPg.empresas.map((emp, idx) => {
                    return (
                      <React.Fragment key={idx}>
                        <CompEmpresa
                          empresa={emp}
                          onClick={() => {
                            serverRouter('centro-esportivo', emp.username)
                          }}
                        />
                      </React.Fragment>
                    )
                  })}
                </Box>
                <Box sx={{ pt: 0.5 }}>
                  <div
                    className='rtz-banner'
                    data-rtz-espaco-id='117'
                    style={{ width: '320px', height: '100px', overflow: 'hidden' }}
                    data-rtz-width='320'
                    data-rtz-height='100'
                    title='Espaço publicitário'
                    data-rtz-display-formato='imagem_video'
                    data-rtz-tipo-criativo='360'
                    data-rtz-device='mobile'
                  ></div>
                </Box>
              </Box>
            ) : (
              <div className='contain-loading tw-flex-col'>
                <IoChatbubbleEllipsesOutline size={75} style={stDesk.iconNotHorarios} />
                <Typography variant='body1' sx={stDesk.textAviso}>
                  Nenhum centro esportivo encontrado.
                </Typography>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
      {sttAuthCtx.isLogged && <AppBarBottom />}
    </div>
  )
}

const stDesk = {
  containGridPage: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'nowrap',
    padding: '10px',

    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(128, 128, 128, 0.6)',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: 'rgba(128, 128, 128, 0.8)',
    },
    scrollbarWidth: 'thin',
    scrollbarColor: 'rgba(128, 128, 128, 0.6) transparent',
  },
  containGridTorneios: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: '10px',
    overflow: 'auto',
  },
  textAviso: {
    color: 'gray',
    fontSize: '16px',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  iconNotHorarios: {
    color: 'gray',
    textAlign: 'center',
    fontSize: '75px',
    marginBottom: '10px',
  },
}
